import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@fortem-monorepo/js-utilities';
const inputVariants = cva('', {
    variants: {
        inputSize: {
            default: 'h-9 has-[>svg]:px-3',
            sm: 'h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5',
        },
    },
    defaultVariants: {
        inputSize: 'default',
    },
});
const Input = React.forwardRef(({ className, inputSize, type, ...props }, forwardedRef) => {
    return (_jsx("input", { ref: forwardedRef, type: type, "data-slot": "input", className: cn(['bg-white'], 'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border flex h-9 w-full min-w-0 rounded-md px-3 py-1 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm', 'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]', 'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive', inputVariants({ inputSize }), className), ...props }));
});
export { Input };
